import React from 'react';
import { glassSurface } from './config/glassTheme';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function PaymentSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const type = params.get('type');
  const pack = params.get('pack');

  const isHobbyPack = type === 'hobby_pack';

  const packNames = {
    starter:  'Starter',
    explorer: 'Explorer',
    creator:  'Creator',
    ultimate: 'Ultimate',
  };

  const packSpecs = {
    starter:  50,
    explorer: 100,
    creator:  200,
    ultimate: 500,
  };

  const packName = pack ? packNames[pack] || pack : '';
  const packSpecCount = pack ? packSpecs[pack] || '' : '';

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={{
          ...styles.icon,
          background: isHobbyPack ? '#fef3c7' : '#d1fae5',
          color: isHobbyPack ? '#92400e' : '#059669',
        }}>
          {isHobbyPack ? '🎒' : '✓'}
        </div>

        <h1 style={styles.title}>
          {isHobbyPack ? 'Hobby Pack Activated!' : 'Payment Successful!'}
        </h1>

        <p style={styles.text}>
          {isHobbyPack
            ? `Your ${packName} Hobby Pack is now active. You have ${packSpecCount} specs ready to use - they never expire, so go at your own pace.`
            : 'Your subscription is now active. It may take a moment to reflect in your dashboard.'}
        </p>

        {isHobbyPack && (
          <div style={styles.hobbyDetails}>
            <div style={styles.hobbyDetailRow}>
              <span style={styles.hobbyDetailIcon}>✓</span>
              <span>Full access to all live generators</span>
            </div>
            <div style={styles.hobbyDetailRow}>
              <span style={styles.hobbyDetailIcon}>✓</span>
              <span>{packSpecCount} specs - never expire</span>
            </div>
            <div style={styles.hobbyDetailRow}>
              <span style={styles.hobbyDetailIcon}>✓</span>
              <span>1,100+ selectable controls per generator</span>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button style={styles.btn} onClick={() => { window.location.href = '/dashboard'; }}>
            Go to Dashboard
          </button>
          {isHobbyPack && (
            <button
              style={{ ...styles.btn, background: 'linear-gradient(135deg, #334155, #881337)' }}
              onClick={() => navigate('/generators')}
            >
              Browse Generators
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={{ ...styles.icon, background: '#fee2e2', color: '#dc2626' }}>✕</div>
        <h1 style={styles.title}>Payment Cancelled</h1>
        <p style={styles.text}>No charge was made. You can return to upgrade whenever you're ready.</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button style={styles.btn} onClick={() => navigate('/upgrade')}>View Plans</button>
          <button style={{ ...styles.btn, background: '#f0f0f0', color: '#333' }} onClick={() => navigate('/dashboard')}>Dashboard</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #334155, #881337)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  card: {
    background: '#fff',
    borderRadius: 12,
    padding: '48px 40px',
    maxWidth: 480,
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  icon: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    fontSize: 28,
    fontWeight: 900,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 24px',
  },
  title: {
    fontSize: 24,
    fontWeight: 800,
    color: '#1a1a1a',
    marginBottom: 12,
  },
  text: {
    color: '#666',
    fontSize: 15,
    lineHeight: 1.6,
    marginBottom: 20,
  },
  hobbyDetails: {
    background: '#fef3c7',
    border: '1px solid #fbbf24',
    borderRadius: 10,
    padding: '14px 18px',
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    textAlign: 'left',
  },
  hobbyDetailRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontSize: 14,
    color: '#92400e',
    fontWeight: 600,
  },
  hobbyDetailIcon: {
    color: '#d97706',
    fontWeight: 800,
    fontSize: 13,
    flexShrink: 0,
  },
  btn: {
    ...glassSurface('#5B21B6', '#8b5cf6', '#a855f7'),
    borderRadius: 8,
    padding: '12px 28px',
    fontWeight: 700,
    fontSize: 15,
    cursor: 'pointer',
    marginBottom: 8,
  },
};
